import type { AiChatReference, Insight } from '~/components/AiChat/types';
import { CONFIGURATION_FEATURES_NAMES } from '~/Types';

export interface InsightsResponse {
  insights: Insight[];
  references: Record<string, AiChatReference>;
}

export const INSIGHT_KEY_TO_LEVEL: Record<string, number> = {
  inconsistency: 1,
  liability_implications: 2,
  risk_factors: 3,
  complexity: 3,
};

export const DEFAULT_INSIGHT_LEVEL = Number.MAX_SAFE_INTEGER;

// Map of insight key patterns to their controlling feature flags
export const INSIGHT_FEATURE_FLAG_MAPPING: Record<string, string> = {
  reinsurance_policy_layers_: CONFIGURATION_FEATURES_NAMES.AI_SERVICE_INSIGHTS_CONTRACT_ANALYSIS_DISPLAY,
};

export const orderInsightsByKey = (a: Insight, b: Insight): number => {
  try {
    const aLevel = INSIGHT_KEY_TO_LEVEL[a.insight_key] ?? DEFAULT_INSIGHT_LEVEL;
    const bLevel = INSIGHT_KEY_TO_LEVEL[b.insight_key] ?? DEFAULT_INSIGHT_LEVEL;
    if (aLevel === bLevel) return 0;
    return aLevel > bLevel ? 1 : -1;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('An error occurred while sorting the insights', e);
    return 0;
  }
};

export const processInsightsResponse = (data: InsightsResponse): InsightsResponse => ({
  references: data.references || {},
  insights: data.insights.map((insight) => ({
    ...insight,
    // Temporary fix for claim_action_plan subtitle
    // https://fivesigma.atlassian.net/browse/NGTPA-19858
    sub_title: insight.insight_key === 'claim_action_plan' ? '' : insight.sub_title,
  })),
});
